//
//
//
//
//
//

export default {
  // TODO: Use one of PwrError or ErrorDisplay everywhere
  name: 'error-display',
  props: {
    display_message: {
      type: String,
      default: 'Error while loading',
    },
    error: {
      default: null,
    },
  },
  watch: {
    error() {
      if (this.error !== null) {
        this.$container.logger.capture(this.error);
      }
    },
  },
  computed: {
    showErrorMessage() {
      return this.error !== null;
    },
    errorMessage() {
      if (this.error !== null) {
        if (typeof this.error === 'string') {
          return this.error;
        }
        return this.error.message;
      }
      return '';
    },
  },
};
